import * as types from 'modulesV2/constants';

const initialState = {
  isVisible: false,
};

export default function welcomeBack(state = initialState, action) {
  switch (action.type) {
    case types.SET_WELCOME_BACK_UI_STATE:
      return {
        isVisible: action.isVisible,
      };
    default:
      return state;
  }
}
